import React, { FC, useContext } from 'react';

import { ListContext, cnListBoxItem } from '../utils';
import { IconSelectSkinny } from '../../../icons';
import { useTheme } from '../../../lib/theme/ThemeProvider';

interface IconSelectionProps {
    isSelected: boolean;
}

export const IconSelection: FC<IconSelectionProps> = ({ isSelected }) => {
    const { size, displaySelection } = useContext(ListContext);
    const { iconSize } = useTheme().sizeTokens[size];
    const icon = <IconSelectSkinny className={cnListBoxItem('icon', { right: true })} size={iconSize} />;

    return <>{displaySelection && isSelected && icon}</>;
};
